<template>
	<div class="lead-skip-reason">
		<Checkbox
			v-model="value.skip"
			:check-name="'reason-' + value.value"
			:value="value.value"
			:inline="false"
			@change="$emit('change', value.skip)"
		>
			{{ conditionText }}
			<span
				v-if="value.recommended"
				class="body_S"
			> (recommended)</span>

			<InfoTip
				v-if="value.tooltip"
				:tip="value.tooltip"
				style="margin-left: 3px; vertical-align: bottom;"
			/>
		</Checkbox>
	</div>
</template>

<script setup>
import skipConditionText from "@/js/helpers/skipConditionText";

const props = defineProps({
	value: {
		type: Object,
		required: true,
	}
})

const conditionText = skipConditionText(props.value.value)
</script>

<style lang="sass">
.lead-skip-reason
	margin-bottom: 15px
</style>
